import { render, staticRenderFns } from "./icCenter.vue?vue&type=template&id=473cd501"
import script from "./icCenter.vue?vue&type=script&lang=js"
export * from "./icCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports